<template>
  <div>
    <v-app-bar app clipped-left class="mt-16 sub-app-bar px-5">
      <v-row justify="space-around">
        <v-col>
          <p class="title">{{ $t('book/building:overview.sub-bar.title') }}</p>
          <p class="subtitle">{{ $t('common:dashboard') }}</p>
        </v-col>
        <v-col cols="4" sm="5" md="4" lg="3" xl="2" align-self="center" class="text-right">
          <BuildingDialogForm ref="buildingForm"/>
        </v-col>
      </v-row>
    </v-app-bar>

    <div class="px-9">
      <v-row>
        <v-col>
          <v-btn color="greyBold" text @click="storeCardView(cardView = !cardView)">
            <v-icon left>list_alt</v-icon>
              {{ $t('book/building:overview.dashboard.change-view') }}
          </v-btn>
        </v-col>
      </v-row>
    </div>
      
      <DashboardPaginated 
        v-show="cardView"
        ref="buildingDashboard"
        @updateData="updateDashboard"
        @viewElement="viewBuilding"
        @cardAction1="addFacility"
        @cardAction2="addRole"
        :itemCardBtn1Text="$t('common:facility')"
        :itemCardBtn2Text="$t('common:role')"
        :itemCardBtn1Tooltip="$t('book/building:overview.dashboard.card-btn.facility')"
        :itemCardBtn2Tooltip="$t('book/building:overview.dashboard.card-btn.role')"
        :itemCardViewIconTooltip="$t('book/building:overview.dashboard.card-btn.view')"
        itemCardHideBtn3
        @cacheCommit="$store.commit('book/common/storeCommonSearch', $event)"
        :cachedSearch="commonSearch"
        is-building
    />
        
    <DataTablePaginated
        v-show="!cardView"
        ref="table"
        class="px-9"
        :headers="headers"
        icon="edit"
        :iconTooltip="$t('buttons:edit')"
        @clickedButton1="viewBuilding"
        @updateTableData="updateDashboard"
        image="thumbnailPath"
        imageAlt="building_thumbnail.png"
        sortBy="name"
        @cacheCommit="$store.commit('book/common/storeCommonSearch', $event)"
        :cachedSearch="commonSearch"
    />
  </div>
</template>

<script>

import BuildingService from "@/modules/book/services/building-service";

import DashboardPaginated from "@/modules/core/components/DashboardPaginated"
import DataTablePaginated from "@/modules/core/components/DataTable/DataTablePaginated";
import BuildingDialogForm from "./BuildingDialogForm"

import {mapGetters} from 'vuex'

export default {
  components: {
    DashboardPaginated,
    DataTablePaginated,
    BuildingDialogForm
  },
  data() {
    return {
      cardView: true
    };
  },
  computed: {
    headers() {
      return [
        {text: this.$t("book/building:overview.dashboard.thumbnail"), value: "image", sortable: false},
        {text: this.$t('common:name'), value: "name"},
        {text: this.$t("common:city"), value: "address_city"},
        {text: this.$t("common:address"), value: "address_street"},
        {text: this.$t("common:object-number"), value: "objectNumber"},
        /*{
        text: this.$t("book/building:overview.t-facilities"),
        value: "facilities",
        },*/
        {text: "", value: "controls", sortable: false},
      ];
    },
    ...mapGetters('book/common', ['commonSearch']),
  },
  watch:{
    commonSearch(value){
      if(this.cardView) {
        this.$refs.table.search = value;
      } else {
        this.$refs.buildingDashboard.search = value;
      }
    }
  }, 
  beforeRouteEnter(to, from, next) {
    next(vm => {

      if(to.query.openForm) {
        vm.$refs.buildingForm.dialog = true;
      }
    });
  },
  methods: {
    updateDashboard(options, search) {
      if(!search) search = '';
      BuildingService.readAllPaginatedFromAPI(
        options.page - 1,
        options.itemsPerPage,
        search,
        options.sortBy,
        options.sortDesc,
        (resp) => {
          this.$refs.table.fillTableData(resp.data)
          this.$refs.buildingDashboard.fillDashboard(resp.data)
        }
      )
    },
    viewBuilding(data) {
      this.$router.push(`/${this.$store.state.manager.bookModuleUrl}/buildings/edit/${data.id}#dashboard`);
    },

    addFacility(item) {
      this.$router.push(`/${this.$store.state.manager.bookModuleUrl}/facilities?building=${item.id}`);
    },

    addRole(item) {
      this.$router.push(`/${this.$store.state.manager.bookModuleUrl}/buildings/edit/${item.id}#roles`)
    },
    storeCardView(item) {
      this.$store.commit('book/building/storeCardViewState', item)
    }
  },
  mounted() {
    this.cardView = this.$store.state.book.building.cardView;
  }
};
</script>